import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const TRIANGLE_PATH = 'M24 0.000206642V24.0002L0 0.000206642H24Z';

const FORM_ACCENT_COLOR = '#7B8FDB';
const LIGHT_BRAND_COLOR = '#233166';
const DARK_BRAND_COLOR = '#5D75D1';

const RED_ACCENT_COLOR = '#E56465';

export type SharedSvgVariant = 'default' | 'formAccent' | 'red';
interface SharedSvgProps extends SvgIconProps {
  variant?: SharedSvgVariant;
  width?: number;
  height?: number;
}

export default function SharedSvg({
  variant = 'default',
  width = 24,
  height = 24,
  sx,
  ...props
}: SharedSvgProps) {
  const theme = useTheme();

  let fill: string;

  switch (variant) {
    case 'formAccent':
      fill = FORM_ACCENT_COLOR;
      break;
    case 'red':
      fill = RED_ACCENT_COLOR;
      break;
    default:
      fill =
        theme.palette.mode === 'light' ? LIGHT_BRAND_COLOR : DARK_BRAND_COLOR;
  }

  return (
    <SvgIcon
      sx={{
        width,
        height,
        ...sx,
      }}
      aria-hidden="true"
      {...props}
    >
      <path d={TRIANGLE_PATH} fill={fill} />
    </SvgIcon>
  );
}
